/**
 * LOT-UI-03a — En-tête de page staff (titre + retour explicite + actions).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const PageHeader = ({
  title,
  subtitle,
  backTo,
  backLabel = 'Retour',
  icon: Icon,
  actions,
  children,
  testId = 'page-header',
}) => (
  <div className="mb-6 space-y-4" data-testid={testId}>
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="flex items-start gap-3 min-w-0">
        {backTo && (
          <Link
            to={backTo}
            className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-colors border border-white/10 bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white"
            aria-label={backLabel}
            data-testid="page-header-back"
          >
            <ChevronLeft className="w-5 h-5" />
          </Link>
        )}
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-black text-white flex items-center gap-2 truncate" data-testid="page-header-title">
            {Icon && <Icon className="w-6 h-6 flex-shrink-0 text-red-400" />}
            <span className="truncate">{title}</span>
          </h1>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1" data-testid="page-header-subtitle">{subtitle}</p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap sm:justify-end" data-testid="page-header-actions">
          {actions}
        </div>
      )}
    </div>
    {children}
  </div>
);

export default PageHeader;
